var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1.04289","y1":"16.2929","x2":"16.0429","y2":"1.29289","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"1.70711","y1":"1.29289","x2":"16.7071","y2":"16.2929","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Cross.defaultProps = {"width":"18","height":"17","viewBox":"0 0 18 17","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
